module.exports = __webpack_public_path__ + "img/dy.f63f808e.png";